<template>
  <div class="gp-number" :class="{ focusing: isFocusing }">
    <button class="control control-minus" @click="decrease">
      <i class="icon icon-minus"></i>
    </button>
    <input v-focus="autofocus" ref="search" type="number" :placeholder="placeholder" @mouseover="onHover" @mouseleave="onLeave" @focus="onFocus" @blur="onBlur" @input="onInput" @keyup="onKeyup" v-model.number="val" autocomplete="new-password" />
    <button class="control control-plus" @click="increase">
      <i class="icon icon-plus"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: "GpNumber",
  props: {
    value: {
      type: Number,
      default: 0
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: -Infinity
    },
    max: {
      type: Number,
      default: Infinity
    }
  },
  data() {
    return {
      val: 0,
      isFocusing: false
    };
  },
  watch: {
    value(value) {
      this.val = value;
    }
  },
  mounted() {
    this.val = this.value;
  },
  methods: {
    onFocus(e) {
      this.$emit("focus", e);
      this.isFocusing = true;
    },
    onBlur(e) {
      this.$emit("blur", e);
      this.isFocusing = false;
    },
    onHover() {
      this.$emit("hover", this.val);
    },
    onLeave() {
      this.$emit("leave", this.val);
    },
    onInput() {
      this.checkRange();
      this.$emit("input", this.val);
      this.$emit("change", this.val);
    },
    onKeyup(event) {
      if (event.keyCode === 13) {
        this.$emit("keyup:enter", this.val);
      } else {
        this.$emit("keyup", this.val);
      }
    },
    decrease() {
      this.val--;
      this.onInput();
    },
    increase() {
      this.val++;
      this.onInput();
    },
    checkRange() {
      if (this.val < this.min) {
        this.val = this.min;
      }
      if (this.val > this.max) {
        this.val = this.max;
      }
    }
  }
};
</script>
<style lang="scss">
.gp-number {
  display: flex;
  align-self: flex-start;
  position: relative;
  width: 100%;
  @include trans-all;

  $controlSize: 40px;

  input {
    display: flex;
    padding: 10px 12px;
    line-height: 18px;
    border-radius: 0;
    -moz-appearance: textfield;
    flex: 1;
    max-width: calc(100% - #{$controlSize*2});
    text-align: center;

    border-left: 1px solid $light3;
    border-right: 1px solid $light3;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    &:focus {
      border-color: $textLightModeHigh;
    }
    &:hover {
      background-color: $light1;
    }

    &::placeholder {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 17px;
    }
  }

  .control {
    width: $controlSize;
    height: $controlSize;
    background-color: $light1;
    border: none;
    outline: none;
    &:not(.disabled),
    &:not(:disabled) {
      cursor: pointer;
      &:hover {
        background-color: $light2; 
      }
    }
    @include flex-center;
  }
}
</style>
